<script setup lang="ts">
import IconAlarmClock from '@/assets/icons/IconAlarmClock.vue'
import IconAlertTriangle from '@/assets/icons/IconAlertTriangle.vue'
import IconAnalytics from '@/assets/icons/IconAnalytics.vue'
import IconArrowBack from '@/assets/icons/IconArrowBack.vue'
import IconArrowDown from '@/assets/icons/IconArrowDown.vue'
import IconArrowLeft from '@/assets/icons/IconArrowLeft.vue'
import IconArrowRight from '@/assets/icons/IconArrowRight.vue'
import IconBell from '@/assets/icons/IconBell.vue'
import IconBlockStop from '@/assets/icons/IconBlockStop.vue'
import IconBuilding from '@/assets/icons/IconBuilding.vue'
import IconBuilding2 from '@/assets/icons/IconBuilding2.vue'
import IconCalendar from '@/assets/icons/IconCalendar.vue'
import IconCheck from '@/assets/icons/IconCheck.vue'
import IconCheckmarkDone from '@/assets/icons/IconCheckmarkDone.vue'
import IconChevronDown from '@/assets/icons/IconChevronDown.vue'
import IconChevronLeft from '@/assets/icons/IconChevronLeft.vue'
import IconChevronRight from '@/assets/icons/IconChevronRight.vue'
import IconChevronsLeft from '@/assets/icons/IconChevronsLeft.vue'
import IconChevronsRight from '@/assets/icons/IconChevronsRight.vue'
import IconChevronUp from '@/assets/icons/IconChevronUp.vue'
import IconCircleCheck from '@/assets/icons/IconCircleCheck.vue'
import IconClock from '@/assets/icons/IconClock.vue'
import IconClose from '@/assets/icons/IconClose.vue'
import IconCloud from '@/assets/icons/IconCloud.vue'
import IconCopy from '@/assets/icons/IconCopy.vue'
import IconCoupon from '@/assets/icons/IconCoupon.vue'
import IconCreditCard from '@/assets/icons/IconCreditCard.vue'
import IconCrown from '@/assets/icons/IconCrown.vue'
import IconDelete from '@/assets/icons/IconDelete.vue'
import IconDeliveryTruck from '@/assets/icons/IconDeliveryTruck.vue'
import IconDownload from '@/assets/icons/IconDownload.vue'
import IconDuplicate from '@/assets/icons/IconDuplicate.vue'
import IconEdit from '@/assets/icons/IconEdit.vue'
import IconEye from '@/assets/icons/IconEye.vue'
import IconFileQuestion from '@/assets/icons/IconFileQuestion.vue'
import IconFilter from '@/assets/icons/IconFilter.vue'
import IconFolderOpen from '@/assets/icons/IconFolderOpen.vue'
import IconGlobe from '@/assets/icons/IconGlobe.vue'
import IconGrid from '@/assets/icons/IconGrid.vue'
import IconGroupUser from '@/assets/icons/IconGroupUser.vue'
import IconHome from '@/assets/icons/IconHome.vue'
import IconInfo from '@/assets/icons/IconInfo.vue'
import IconKeyRound from '@/assets/icons/IconKeyRound.vue'
import IconLanguages from '@/assets/icons/IconLanguages.vue'
import IconLayoutDashboard from '@/assets/icons/IconLayoutDashboard.vue'
import IconLoader2 from '@/assets/icons/IconLoader2.vue'
import IconLock from '@/assets/icons/IconLock.vue'
import IconMail from '@/assets/icons/IconMail.vue'
import IconMapPin from '@/assets/icons/IconMapPin.vue'
import IconMic from '@/assets/icons/IconMic.vue'
import IconMicOff from '@/assets/icons/IconMicOff.vue'
import IconMicroscope from '@/assets/icons/IconMicroscope.vue'
import IconMinus from '@/assets/icons/IconMinus.vue'
import IconMoreHorizontal from '@/assets/icons/IconMoreHorizontal.vue'
import IconOctagonX from '@/assets/icons/IconOctagonX.vue'
import IconPackage from '@/assets/icons/IconPackage.vue'
import IconPackageBox from '@/assets/icons/IconPackageBox.vue'
import IconPanelLeft from '@/assets/icons/IconPanelLeft.vue'
import IconPause from '@/assets/icons/IconPause.vue'
import IconPhone from '@/assets/icons/IconPhone.vue'
import IconPlus from '@/assets/icons/IconPlus.vue'
import IconPlusBig from '@/assets/icons/IconPlusBig.vue'
import IconRefresh from '@/assets/icons/IconRefresh.vue'
import IconRiyal from '@/assets/icons/IconRiyal.vue'
import IconSearch from '@/assets/icons/IconSearch.vue'
import IconSend from '@/assets/icons/IconSend.vue'
import IconSettings from '@/assets/icons/IconSettings.vue'
import IconShieldAlert from '@/assets/icons/IconShieldAlert.vue'
import IconShieldCheck from '@/assets/icons/IconShieldCheck.vue'
import IconShieldOff from '@/assets/icons/IconShieldOff.vue'
import IconShoppingBag from '@/assets/icons/IconShoppingBag.vue'
import IconShoppingCart from '@/assets/icons/IconShoppingCart.vue'
import IconShoppingCartSmall from '@/assets/icons/IconShoppingCartSmall.vue'
import IconSlidersHorizontal from '@/assets/icons/IconSlidersHorizontal.vue'
import IconSparkles from '@/assets/icons/IconSparkles.vue'
import IconStar from '@/assets/icons/IconStar.vue'
import IconTag from '@/assets/icons/IconTag.vue'
import IconTrashBin from '@/assets/icons/IconTrashBin.vue'
import IconTrendingDown from '@/assets/icons/IconTrendingDown.vue'
import IconTrendingUp from '@/assets/icons/IconTrendingUp.vue'
import IconUpload from '@/assets/icons/IconUpload.vue'
import IconUsers from '@/assets/icons/IconUsers.vue'
import IconSmartphone from '@/assets/icons/IconSmartphone.vue'
import IconTablet from '@/assets/icons/IconTablet.vue'
import IconMonitor from '@/assets/icons/IconMonitor.vue'
import {
  EyeOff,
  GripVertical,
  LayoutTemplate,
  Palette,
  Square,
  Store,
  Type,
  LayoutGrid,
  GalleryHorizontalEnd,
  Image as ImageIcon,
  List,
  Undo2,
} from 'lucide-vue-next'
import IconZap from '@/assets/icons/IconZap.vue'
import { computed, type Component } from 'vue'

const iconMap: Record<string, Component> = {
  'trending-up': IconTrendingUp,
// ...
  'trending-down': IconTrendingDown,
  'checkmark-done': IconCheckmarkDone,
  'delivery-truck': IconDeliveryTruck,
  'alarm-clock': IconAlarmClock,
  'trash-bin': IconTrashBin,
  'package-box': IconPackageBox,
  'shopping-bag': IconShoppingBag,
  'shopping-cart': IconShoppingCart,
  riyal: IconRiyal,
  analytics: IconAnalytics,
  'group-user': IconGroupUser,
  'alert-triangle': IconAlertTriangle,
  'shopping-cart-small': IconShoppingCartSmall,
  'credit-card': IconCreditCard,
  tag: IconTag,
  home: IconHome,
  grid: IconGrid,
  building: IconBuilding,
  coupon: IconCoupon,
  microscope: IconMicroscope,
  settings: IconSettings,
  'arrow-down': IconArrowDown,
  bell: IconBell,
  globe: IconGlobe,
  search: IconSearch,
  calendar: IconCalendar,
  'block-stop': IconBlockStop,
  clock: IconClock,
  plus: IconPlus,
  'arrow-left': IconArrowLeft,
  delete: IconDelete,
  download: IconDownload,
  duplicate: IconDuplicate,
  pause: IconPause,
  edit: IconEdit,
  filter: IconFilter,
  'plus-big': IconPlusBig,
  'arrow-back': IconArrowBack,
  refresh: IconRefresh,
  eye: IconEye,
  'map-pin': IconMapPin,
  mail: IconMail,
  lock: IconLock,
  close: IconClose,
  check: IconCheck,
  'chevron-down': IconChevronDown,
  'chevron-up': IconChevronUp,
  'chevron-right': IconChevronRight,
  'chevron-left': IconChevronLeft,
  'chevrons-left': IconChevronsLeft,
  'chevrons-right': IconChevronsRight,
  'more-horizontal': IconMoreHorizontal,
  minus: IconMinus,
  'panel-left': IconPanelLeft,
  'circle-check': IconCircleCheck,
  info: IconInfo,
  'octagon-x': IconOctagonX,
  loader2: IconLoader2,
  loader: IconLoader2,
  'sliders-horizontal': IconSlidersHorizontal,
  'shield-alert': IconShieldAlert,
  'shield-check': IconShieldCheck,
  'file-question': IconFileQuestion,
  'arrow-right': IconArrowRight,
  'key-round': IconKeyRound,
  phone: IconPhone,
  'shield-off': IconShieldOff,
  building2: IconBuilding2,
  'folder-open': IconFolderOpen,
  'layout-dashboard': IconLayoutDashboard,
  package: IconPackage,
  users: IconUsers,
  trash2: IconTrashBin,
  upload: IconUpload,
  cloud: IconCloud,
  copy: IconCopy,
  send: IconSend,
  sparkles: IconSparkles,
  star: IconStar,
  zap: IconZap,
  crown: IconCrown,
  mic: IconMic,
  'mic-off': IconMicOff,
  languages: IconLanguages,
  smartphone: IconSmartphone,
  tablet: IconTablet,
  monitor: IconMonitor,
  grip: GripVertical,
  palette: Palette,
  type: Type,
  spacing: LayoutTemplate,
  square: Square,
  store: Store,
  'eye-off': EyeOff,
  'layout-grid': LayoutGrid,
  'gallery-horizontal-end': GalleryHorizontalEnd,
  image: ImageIcon,
  list: List,
  'layout-template': LayoutTemplate,
  undo: Undo2,
}

const props = defineProps<{
  name: string
  size?: number
}>()

const iconComponent = computed(() => iconMap[props.name])
</script>

<template>
  <component
    :is="iconComponent"
    v-if="iconComponent"
    class="shrink-0"
    :style="size ? { width: `${size}px`, height: `${size}px` } : undefined"
  />
</template>
